import {
  TOPIC_CONTENT_SOURCES,
  type TopicContentSource,
} from "./topic-content-sources";

export const RESUME_INTERVIEW_SOURCES_A = [
  {
    sourceId: "resume-interview-source-resume",
    topicId: "resume-interview",
    title: "Write a resume",
    publisher: "Workforce Australia",
    url: "https://www.workforceaustralia.gov.au/individuals/coaching/job-applications/resumes",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Australian Government Workforce Australia 공식 본문에서 simple layout, relevant experience·skills, job-tailored ordering, truthful content와 referee permission을 확인",
    reviewStatus: "live_verified",
    claimScope: "호주 job application용 resume 구성·tailoring·referee 일반 기준",
    followUp: "지원 직전 job ad, employer requirements와 file format을 재확인",
  },
  {
    sourceId: "resume-interview-source-cover",
    topicId: "resume-interview",
    title: "Write a cover letter",
    publisher: "Workforce Australia",
    url: "https://www.workforceaustralia.gov.au/individuals/coaching/job-applications/cover-letters",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Workforce Australia 공식 본문에서 one-page tailored cover letter, job title·interest·skills·availability와 ad keywords 사용을 확인",
    reviewStatus: "live_verified",
    claimScope: "job-specific cover letter의 목적·길이·핵심정보",
    followUp: "job ad가 cover letter를 요구·제외하는지와 addressee·reference number 확인",
  },
  {
    sourceId: "resume-interview-source-applications",
    topicId: "resume-interview",
    title: "Tips for successful job applications",
    publisher: "Workforce Australia",
    url: "https://www.workforceaustralia.gov.au/individuals/coaching/job-applications/job-application-tips",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Workforce Australia 공식 본문에서 each-job application, screening questions, selection criteria, STAR evidence, proofreading와 saved copies를 확인",
    reviewStatus: "live_verified",
    claimScope: "quality job application·selection criteria·screening response의 일반 기준",
    followUp: "employer instructions, word limit, selection criteria와 closing time을 제출 전에 확인",
  },
  {
    sourceId: "resume-interview-source-interview",
    topicId: "resume-interview",
    title: "Prepare for a job interview",
    publisher: "Workforce Australia",
    url: "https://www.workforceaustralia.gov.au/individuals/coaching/job-applications/job-interviews",
    trust: 5,
    jurisdiction: "australia",
    checkedAt: "2026-07-17",
    verificationMethod:
      "Workforce Australia 공식 본문에서 employer research, relevant examples, common·behavioural questions, STAR-style preparation, salary research와 interview logistics를 확인",
    reviewStatus: "live_verified",
    claimScope: "호주 job interview 준비·답변·질문의 일반 기준",
    followUp: "interview format, panel, location·technology, assessment와 requested documents를 invitation에서 확인",
  },
] as const satisfies readonly TopicContentSource[];

const mutableSources = TOPIC_CONTENT_SOURCES as unknown as TopicContentSource[];
for (const source of RESUME_INTERVIEW_SOURCES_A) {
  if (!mutableSources.some((existing) => existing.sourceId === source.sourceId)) {
    mutableSources.push(source);
  }
}
